<template>
	<div>{{ currentFunFact }}</div>
</template>

<script>
const funFacts = [
	"The ancient Roman festival of Lupercalia, celebrated from February 13th to 15th, is considered the precursor to Valentine's Day.",
	"Saint Valentine, the patron saint of lovers, is said to have performed secret marriages for Roman soldiers who were forbidden to marry.",
	"The heart symbol we associate with love and Valentine's Day has been used as a symbol of love since the 13th century.",
	"The oldest known Valentine's letter still in existence was written in 1415 by Charles, Duke of Orleans, to his wife while he was imprisoned in the Tower of London.",
	"In the Middle Ages, young men and women would draw names from a box to see who their Valentine would be. This practice gave rise to the modern tradition of exchanging Valentine's Day cards.",
	"The first recorded Valentine's Day card was sent in 1415 by Charles, Duke of Orleans, to his wife.",
	"Chocolate is a popular gift on Valentine's Day, with Americans spending approximately $1.8 billion on chocolate for the holiday in 2020.",
	"In Japan, Valentine's Day is a day when women give chocolates to men, while White Day, celebrated one month later, is when men give gifts to women.",
	"Red roses are the traditional flower of love and are often given on Valentine's Day as a symbol of love and passion.",
	"Cupid, the Roman god of love, is often depicted as a cherubic baby with wings and a bow and arrow.",
	"In ancient Greece, the goddess of love and beauty, Aphrodite, was associated with the rose and the dove.",
	"In medieval Europe, the month of February was often associated with love and romance, and was known as the month of St. Valentine.",
	"The tradition of sending anonymous Valentine's Day cards dates back to the late 17th century.",
	'The first mass-produced Valentine\'s Day cards were produced in the early 19th century by Esther A. Howland, an American woman known as the "Mother of the Valentine."',
	"The first commercial Valentine's Day card was produced in 1913 and featured a design by illustrator J.C. Horsley.",
	"In the United States, approximately 150 million Valentine's Day cards are exchanged each year, making it the second-largest card-sending holiday after Christmas.",
	"In Finland, Valentine's Day is called Ystävänpäivä, which means \"Friend's Day.\"",
	"In South Africa, the holiday is called Lupercalia, after the ancient Roman festival, and is celebrated with picnics, music, and dancing.",
	'In Denmark, Valentine\'s Day is called Skærtorsdag, which means "Maundy Thursday."',
	"In France, Valentine's Day is called La Saint-Valentin and is a time to celebrate love and romance with your significant other.",
	'In Italy, Valentine\'s Day is called Festa degli Innamorati, which means "Festival of Lovers."',
	"In Sweden, Valentine's Day is called Alla Hjärtans Dag, which means \"All Hearts' Day.\"",
];

export default {
	data() {
		return {
			currentFunFact: null,
			funFacts,
		};
	},
	mounted() {
		// rotate through funfacts and show one instantly
		this.currentFunFact =
			this.funFacts[Math.floor(Math.random() * this.funFacts.length)];
		setInterval(() => {
			this.currentFunFact =
				this.funFacts[Math.floor(Math.random() * this.funFacts.length)];
		}, 5000);
	},
};
</script>

<style></style>
